import React from "react";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";

const PortfolioDetail = () => {
  const { slug } = useParams();
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Portfolio Detail: {slug}
      </Typography>
      <Typography variant="body1">
        This is a placeholder for the portfolio item detail page for <b>{slug}</b>.
      </Typography>
    </Box>
  );
};

export default PortfolioDetail; 